module.exports = __webpack_public_path__ + "img/selbsterfahrung_3000.64c5342b.png";